import styled from 'styled-components'

export const Label = styled.label`
  & span {
    padding-left: 8px;
  }
`
